/**
 * Логика труб: материал по id и труба по умолчанию.
 */
import { pipeSection } from "./catalog";
import type { PipeCatalogItem } from "./types";

export const pipeItemById = (id: string): PipeCatalogItem | null =>
	pipeSection.items.find((item) => item.id === id) ?? null;

/** Труба, которой ведут трассы, пока пользователь не выбрал другую. */
export const defaultPipe = (): PipeCatalogItem => pipeSection.items[0];
